import Helmet from "react-helmet";
import { Navigate, Outlet, Route } from "react-router";
import { createGlobalStyle } from "styled-components";

import Navigation from "./Navigation";
import AppHeader from "../../components/AppHeader";
import RevitParameterTemplateDetail from "./domain/RevitParameterTemplate/Detail";
import RevitParameterTemplateInventory from "./domain/RevitParameterTemplate/Inventory";
import RevitParameterTemplateNew from "./domain/RevitParameterTemplate/New";
import RevitValueDetail from "./domain/RevitValue/Detail";
import RevitValueInventory from "./domain/RevitValue/Inventory";

const GlobalStyle = createGlobalStyle`
    :root {
        --background: royalblue !important;
    }
`;

function App() {
    return (
        <>
            <Helmet>
                <title>revit-parameters</title>
                <meta name="theme-color" content="royalblue" />
            </Helmet>
            <GlobalStyle />
            <AppHeader light />
            <Navigation />
            <Outlet />
        </>
    );
}

export default (
    <Route Component={ App } path="revit-parameters">
        <Route element={ <Navigate to="./RevitParameterTemplates" /> } index />
        <Route path="RevitParameterTemplates">
            <Route Component={ RevitParameterTemplateInventory } index />
            <Route Component={ RevitParameterTemplateNew } path="new" />
            <Route Component={ RevitParameterTemplateDetail } path=":revitParameterTemplateID" />
        </Route>
        <Route path="RevitValues">
            <Route Component={ RevitValueInventory } index />
            <Route Component={ RevitValueDetail } path=":parameterID/:bimClassID?" />
        </Route>
    </Route>
);
